import { useState } from "react";

const GENRES = [
  { id: "pop", name: "Pop", emoji: "🎵", color: "#e91e8c", q: "pop hits 2024" },
  { id: "hiphop", name: "Hip Hop", emoji: "🎤", color: "#8b5cf6", q: "hip hop" },
  { id: "rnb", name: "R&B", emoji: "💜", color: "#6d28d9", q: "rnb soul" },
  { id: "rock", name: "Rock", emoji: "🎸", color: "#ef4444", q: "rock hits" },
  { id: "kpop", name: "K-Pop", emoji: "⭐", color: "#1db954", q: "kpop 2024" },
  { id: "myanmar", name: "Myanmar", emoji: "🇲🇲", color: "#f59e0b", q: "myanmar music" },
  { id: "jazz", name: "Jazz", emoji: "🎷", color: "#38bdf8", q: "jazz" },
  { id: "classical", name: "Classical", emoji: "🎻", color: "#84cc16", q: "classical" },
  { id: "electronic", name: "Electronic", emoji: "🎧", color: "#06b6d4", q: "electronic music" },
  { id: "christian", name: "Christian", emoji: "✝️", color: "#f97316", q: "christian music" },
  { id: "country", name: "Country", emoji: "🤠", color: "#d97706", q: "country music" },
  { id: "latin", name: "Latin", emoji: "💃", color: "#ec4899", q: "latin music" },
];

const ARTISTS_BY_GENRE = {
  "pop": [
    { id: "taylor", name: "Taylor Swift", color: "#8b5cf6" },
    { id: "ariana", name: "Ariana Grande", color: "#ec4899" },
    { id: "edsheeran", name: "Ed Sheeran", color: "#ef4444" },
    { id: "adele", name: "Adele", color: "#3b82f6" },
    { id: "post", name: "Post Malone", color: "#6d28d9" },
    { id: "billie", name: "Billie Eilish", color: "#64748b" },
  ],
  "hiphop": [
    { id: "drake", name: "Drake", color: "#f59e0b" },
    { id: "kendrick", name: "Kendrick Lamar", color: "#e91429" },
    { id: "travis", name: "Travis Scott", color: "#1a1a2e" },
    { id: "post", name: "Post Malone", color: "#6d28d9" },
    { id: "eminem", name: "Eminem", color: "#3b82f6" },
    { id: "jcole", name: "J. Cole", color: "#f59e0b" },
  ],
  "rnb": [
    { id: "weeknd", name: "The Weeknd", color: "#7c3aed" },
    { id: "sza", name: "SZA", color: "#ec4899" },
    { id: "frank", name: "Frank Ocean", color: "#14b8a6" },
    { id: "beyonce", name: "Beyoncé", color: "#f59e0b" },
    { id: "usher", name: "Usher", color: "#ef4444" },
  ],
  "kpop": [
    { id: "bts", name: "BTS", color: "#1db954" },
    { id: "blackpink", name: "BLACKPINK", color: "#e91e8c" },
    { id: "twice", name: "TWICE", color: "#ec4899" },
    { id: "exo", name: "EXO", color: "#3b82f6" },
    { id: "straykids", name: "Stray Kids", color: "#f59e0b" },
    { id: "newjeans", name: "NewJeans", color: "#8b5cf6" },
  ],
  "myanmar": [
    { id: "layPhyu", name: "Lay Phyu", color: "#f97316" },
    { id: "davidLai", name: "David Lai", color: "#1db954" },
    { id: "rZarni", name: "R Zarni", color: "#4776e6" },
    { id: "saiSai", name: "Sai Sai", color: "#8b5cf6" },
    { id: "alphaNine", name: "Alpha Nine", color: "#ec4899" },
    { id: "thetHtar", name: "Thet Htar", color: "#14b8a6" },
    { id: "chitThuWai", name: "Chit Thu Wai", color: "#f59e0b" },
    { id: "htooEainThin", name: "Htoo Eain Thin", color: "#ef4444" },
  ],
  "rock": [
    { id: "coldplay", name: "Coldplay", color: "#3b82f6" },
    { id: "linkinpark", name: "Linkin Park", color: "#ef4444" },
    { id: "imagine", name: "Imagine Dragons", color: "#f59e0b" },
    { id: "acdc", name: "AC/DC", color: "#1a1a1a" },
    { id: "queen", name: "Queen", color: "#8b5cf6" },
  ],
  "christian": [
    { id: "hillsong", name: "Hillsong Worship", color: "#3b82f6" },
    { id: "bethel", name: "Bethel Music", color: "#1db954" },
    { id: "elevation", name: "Elevation Worship", color: "#f59e0b" },
    { id: "lauraDaigle", name: "Lauren Daigle", color: "#ec4899" },
    { id: "tomfellite", name: "Tom Felite", color: "#8b5cf6" },
  ],
  "jazz": [
    { id: "miles", name: "Miles Davis", color: "#6d28d9" },
    { id: "coltrane", name: "John Coltrane", color: "#14b8a6" },
    { id: "norah", name: "Norah Jones", color: "#f59e0b" },
    { id: "michaelbuble", name: "Michael Bublé", color: "#3b82f6" },
  ],
  "classical": [
    { id: "beethoven", name: "Beethoven", color: "#6d28d9" },
    { id: "mozart", name: "Mozart", color: "#3b82f6" },
    { id: "yiruma", name: "Yiruma", color: "#14b8a6" },
    { id: "ludovico", name: "Ludovico Einaudi", color: "#8b5cf6" },
  ],
  "electronic": [
    { id: "marshmello", name: "Marshmello", color: "#1db954" },
    { id: "alanwalker", name: "Alan Walker", color: "#3b82f6" },
    { id: "avicii", name: "Avicii", color: "#f59e0b" },
    { id: "davidguetta", name: "David Guetta", color: "#ef4444" },
  ],
  "latin": [
    { id: "badbunny", name: "Bad Bunny", color: "#1db954" },
    { id: "shakira", name: "Shakira", color: "#f59e0b" },
    { id: "jbalvin", name: "J Balvin", color: "#ec4899" },
    { id: "maluma", name: "Maluma", color: "#8b5cf6" },
  ],
  "country": [
    { id: "taylorSwift", name: "Taylor Swift", color: "#8b5cf6" },
    { id: "lukeCombs", name: "Luke Combs", color: "#f59e0b" },
    { id: "morganWallen", name: "Morgan Wallen", color: "#ef4444" },
    { id: "blakeS", name: "Blake Shelton", color: "#3b82f6" },
  ],
};

// Fallback artists if no genre selected
const DEFAULT_ARTISTS = [
  { id: "taylor", name: "Taylor Swift", color: "#8b5cf6" },
  { id: "bts", name: "BTS", color: "#1db954" },
  { id: "weeknd", name: "The Weeknd", color: "#7c3aed" },
  { id: "drake", name: "Drake", color: "#f59e0b" },
  { id: "layPhyu", name: "Lay Phyu", color: "#f97316" },
  { id: "blackpink", name: "BLACKPINK", color: "#e91e8c" },
];

export default function Onboarding({ user, onComplete }) {
  const [step, setStep] = useState(0); // 0=welcome, 1=role, 2=genres, 3=artists, 4=done
  const [role, setRole] = useState(null); // "fan" or "artist"
  const [selectedGenres, setSelectedGenres] = useState([]);
  const [selectedArtists, setSelectedArtists] = useState([]);

  function toggleGenre(id) {
    setSelectedGenres(prev => prev.includes(id) ? prev.filter(g => g !== id) : [...prev, id]);
  }

  function toggleArtist(id) {
    setSelectedArtists(prev => prev.includes(id) ? prev.filter(a => a !== id) : [...prev, id]);
  }

  function handleComplete() {
    const prefs = {
      genres: selectedGenres,
      artists: selectedArtists,
      role,
      genreQueries: GENRES.filter(g => selectedGenres.includes(g.id)).map(g => g.q),
     artistNames: Object.values(ARTISTS_BY_GENRE).flat().filter((a, i, arr) => arr.findIndex(x => x.id === a.id) === i).filter(a => selectedArtists.includes(a.id)).map(a => a.name),
      completed: true,
    };
    localStorage.setItem(`onboarding_${user.uid}`, JSON.stringify(prefs));
    onComplete(prefs);
  }

  function skip() {
    localStorage.setItem(`onboarding_${user.uid}`, JSON.stringify({ completed: true, genres: [], artists: [], role: "fan" }));
    onComplete({ genres: [], artists: [], genreQueries: [], artistNames: [], role: "fan" });
  }

  return (
    <div style={{ minHeight: "100vh", background: "#000", color: "#fff", fontFamily: "'DM Sans', sans-serif", display: "flex", flexDirection: "column" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=Syne:wght@700;800&family=DM+Sans:wght@400;500;600&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::-webkit-scrollbar { display: none; }
        @keyframes pop { from { transform: scale(0.5); opacity: 0; } to { transform: scale(1); opacity: 1; } }
        @keyframes fadeUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
      `}</style>

      {/* WELCOME SCREEN */}
      {step === 0 && (
        <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "40px 24px", textAlign: "center", background: "linear-gradient(160deg, #0d2818 0%, #000 60%)" }}>
         <div style={{ width: 96, height: 96, borderRadius: 28, overflow: "hidden", marginBottom: 28, boxShadow: "0 12px 48px rgba(29,185,84,0.4)", animation: "pop 0.5s ease" }}>
            <img src="/logo192.png" alt="MyMusic" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
          </div>
          <div style={{ fontFamily: "'Instrument Serif', serif", fontSize: 36, letterSpacing: "-1px", marginBottom: 12, lineHeight: 1.1, animation: "fadeUp 0.5s ease 0.1s both" }}>
            Welcome to<br /><span style={{ color: "#1db954" }}>MyMusic</span>
          </div>
          <p style={{ fontSize: 14, color: "#666", lineHeight: 1.8, maxWidth: 280, marginBottom: 12, animation: "fadeUp 0.5s ease 0.2s both" }}>
            The world's first Universal Music Society. Discover, create and connect with music lovers worldwide.
          </p>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 48, animation: "fadeUp 0.5s ease 0.3s both" }}>
            <div style={{ width: 6, height: 6, borderRadius: "50%", background: "#1db954" }} />
           <span style={{ fontSize: 12, color: "#1db954", fontWeight: 600 }}>Music for everyone, everywhere</span>
          </div>
          <button onClick={() => setStep(1)} style={{ width: "100%", maxWidth: 320, padding: "16px", borderRadius: 50, border: "none", background: "#1db954", color: "#000", fontSize: 16, fontWeight: 700, cursor: "pointer", marginBottom: 14, fontFamily: "'Syne',sans-serif", animation: "fadeUp 0.5s ease 0.4s both" }}>
            Get Started →
          </button>
          <button onClick={skip} style={{ background: "none", border: "none", color: "#444", fontSize: 13, cursor: "pointer" }}>
            Skip for now
          </button>
        </div>
      )}

      {/* ROLE SELECTION */}
      {step === 1 && (
        <div style={{ flex: 1, display: "flex", flexDirection: "column", padding: "0 0 120px" }}>
          <div style={{ padding: "48px 24px 24px", background: "linear-gradient(180deg, #0d1f12 0%, #000 100%)" }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: "#1db954", letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: 10 }}>Step 1 of 3</div>
            <div style={{ fontFamily: "'Syne',sans-serif", fontSize: 28, fontWeight: 800, letterSpacing: "-0.5px", marginBottom: 6 }}>Who are you?</div>
            <p style={{ fontSize: 13, color: "#666" }}>Tell us how you want to use MyMusic</p>
          </div>

          <div style={{ height: 2, background: "#111", margin: "0 24px" }}>
            <div style={{ width: "33%", height: "100%", background: "#1db954", borderRadius: 1 }} />
          </div>

          <div style={{ padding: "32px 24px", flex: 1, display: "flex", flexDirection: "column", gap: 16 }}>
            {/* Fan card */}
            <div onClick={() => setRole("fan")} style={{ padding: 24, borderRadius: 20, border: `2px solid ${role === "fan" ? "#1db954" : "#1a1a1a"}`, background: role === "fan" ? "rgba(29,185,84,0.06)" : "#0a0a0a", cursor: "pointer", transition: "all 0.2s" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 16 }}>
                <div style={{ width: 56, height: 56, borderRadius: 16, background: "linear-gradient(135deg, #1e3264, #4776e6)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <svg viewBox="0 0 24 24" style={{ width: 28, height: 28, fill: "none", stroke: "#fff", strokeWidth: 1.8 }}><path d="M3 18v-6a9 9 0 0 1 18 0v6"/><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"/></svg>
                </div>
                <div>
                  <div style={{ fontFamily: "'Syne',sans-serif", fontSize: 20, fontWeight: 800 }}>Music Fan</div>
                  <div style={{ fontSize: 13, color: "#666", marginTop: 2 }}>I love discovering music</div>
                </div>
                {role === "fan" && <div style={{ marginLeft: "auto", width: 24, height: 24, borderRadius: "50%", background: "#1db954", display: "flex", alignItems: "center", justifyContent: "center" }}><svg viewBox="0 0 24 24" style={{ width: 14, height: 14, fill: "none", stroke: "#000", strokeWidth: 3 }}><polyline points="20 6 9 17 4 12"/></svg></div>}
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                {["Stream millions of songs", "Follow your favourite artists", "Join music communities", "Get your Music ID"].map(f => (
                  <div key={f} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <div style={{ width: 5, height: 5, borderRadius: "50%", background: "#1db954", flexShrink: 0 }} />
                    <span style={{ fontSize: 13, color: "#888" }}>{f}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Artist card */}
            <div onClick={() => setRole("artist")} style={{ padding: 24, borderRadius: 20, border: `2px solid ${role === "artist" ? "#f59e0b" : "#1a1a1a"}`, background: role === "artist" ? "rgba(245,158,11,0.06)" : "#0a0a0a", cursor: "pointer", transition: "all 0.2s" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 16 }}>
                <div style={{ width: 56, height: 56, borderRadius: 16, background: "linear-gradient(135deg, #2a1a00, #f59e0b)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <svg viewBox="0 0 24 24" style={{ width: 28, height: 28, fill: "none", stroke: "#fff", strokeWidth: 1.8 }}><path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/></svg>
                </div>
                <div>
                  <div style={{ fontFamily: "'Syne',sans-serif", fontSize: 20, fontWeight: 800 }}>Artist</div>
                  <div style={{ fontSize: 13, color: "#666", marginTop: 2 }}>I create music</div>
                </div>
                {role === "artist" && <div style={{ marginLeft: "auto", width: 24, height: 24, borderRadius: "50%", background: "#f59e0b", display: "flex", alignItems: "center", justifyContent: "center" }}><svg viewBox="0 0 24 24" style={{ width: 14, height: 14, fill: "none", stroke: "#000", strokeWidth: 3 }}><polyline points="20 6 9 17 4 12"/></svg></div>}
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                {["Upload your music for free", "Get verified artist badge", "See your play count analytics", "Build your fanbase worldwide"].map(f => (
                  <div key={f} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <div style={{ width: 5, height: 5, borderRadius: "50%", background: "#f59e0b", flexShrink: 0 }} />
                    <span style={{ fontSize: 13, color: "#888" }}>{f}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div style={{ position: "fixed", bottom: 0, left: 0, right: 0, padding: "16px 24px 32px", background: "linear-gradient(0deg, #000 60%, transparent)" }}>
            <button onClick={() => role && setStep(2)} style={{ width: "100%", maxWidth: 360, display: "block", margin: "0 auto", padding: "15px", borderRadius: 50, border: "none", background: role ? "#1db954" : "#222", color: role ? "#000" : "#555", fontSize: 15, fontWeight: 700, cursor: role ? "pointer" : "not-allowed", fontFamily: "'Syne',sans-serif", transition: "all 0.2s" }}>
              Continue →
            </button>
          </div>
        </div>
      )}

      {/* GENRE SELECTION */}
      {step === 2 && (
        <div style={{ flex: 1, display: "flex", flexDirection: "column", padding: "0 0 100px" }}>
          <div style={{ padding: "48px 24px 24px", background: "linear-gradient(180deg, #0d1f12 0%, #000 100%)" }}>
            <button onClick={() => setStep(1)} style={{ background: "none", border: "none", color: "#1db954", fontSize: 14, cursor: "pointer", marginBottom: 16, display: "flex", alignItems: "center", gap: 6 }}>← Back</button>
            <div style={{ fontSize: 11, fontWeight: 700, color: "#1db954", letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: 10 }}>Step 2 of 3</div>
            <div style={{ fontFamily: "'Syne',sans-serif", fontSize: 26, fontWeight: 800, letterSpacing: "-0.5px", marginBottom: 6 }}>What music do<br />you love?</div>
            <p style={{ fontSize: 13, color: "#666" }}>Pick at least 3 genres to continue</p>
          </div>

          <div style={{ height: 2, background: "#111", margin: "0 24px" }}>
            <div style={{ width: "66%", height: "100%", background: "#1db954", borderRadius: 1 }} />
          </div>

          <div style={{ padding: "20px 16px", flex: 1, overflowY: "auto" }}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>
              {GENRES.map(g => {
                const selected = selectedGenres.includes(g.id);
                return (
                  <div key={g.id} onClick={() => toggleGenre(g.id)} style={{ borderRadius: 14, padding: "16px 8px", background: selected ? g.color : "#111", border: `2px solid ${selected ? g.color : "#1a1a1a"}`, cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", gap: 6, transition: "all 0.2s", transform: selected ? "scale(1.02)" : "scale(1)", boxShadow: selected ? `0 4px 20px ${g.color}40` : "none" }}>
                    <span style={{ fontSize: 26 }}>{g.emoji}</span>
                    <span style={{ fontSize: 12, fontWeight: 600, color: selected ? "#000" : "#ccc", textAlign: "center" }}>{g.name}</span>
                    {selected && <div style={{ width: 20, height: 20, borderRadius: "50%", background: "rgba(0,0,0,0.3)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <svg viewBox="0 0 24 24" style={{ width: 12, height: 12, fill: "none", stroke: "#000", strokeWidth: 3 }}><polyline points="20 6 9 17 4 12"/></svg>
                    </div>}
                  </div>
                );
              })}
            </div>
          </div>

          <div style={{ position: "fixed", bottom: 0, left: 0, right: 0, padding: "16px 24px 32px", background: "linear-gradient(0deg, #000 60%, transparent)", display: "flex", flexDirection: "column", alignItems: "center", gap: 10 }}>
            <p style={{ fontSize: 12, color: "#555" }}>{selectedGenres.length} selected {selectedGenres.length < 3 ? `(need ${3 - selectedGenres.length} more)` : "✓"}</p>
            <button onClick={() => selectedGenres.length >= 3 && setStep(3)} style={{ width: "100%", maxWidth: 320, padding: "15px", borderRadius: 50, border: "none", background: selectedGenres.length >= 3 ? "#1db954" : "#222", color: selectedGenres.length >= 3 ? "#000" : "#555", fontSize: 15, fontWeight: 700, cursor: selectedGenres.length >= 3 ? "pointer" : "not-allowed", fontFamily: "'Syne',sans-serif", transition: "all 0.2s" }}>
              Continue →
            </button>
          </div>
        </div>
      )}

      {/* ARTIST SELECTION */}
      {step === 3 && (
        <div style={{ flex: 1, display: "flex", flexDirection: "column", padding: "0 0 100px" }}>
          <div style={{ padding: "48px 24px 24px", background: "linear-gradient(180deg, #0d1f12 0%, #000 100%)" }}>
            <button onClick={() => setStep(2)} style={{ background: "none", border: "none", color: "#1db954", fontSize: 14, cursor: "pointer", marginBottom: 16, display: "flex", alignItems: "center", gap: 6 }}>← Back</button>
            <div style={{ fontSize: 11, fontWeight: 700, color: "#1db954", letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: 10 }}>Step 3 of 3</div>
            <div style={{ fontFamily: "'Syne',sans-serif", fontSize: 26, fontWeight: 800, letterSpacing: "-0.5px", marginBottom: 6 }}>Pick your<br />favourite artists</div>
            <p style={{ fontSize: 13, color: "#666" }}>Select at least 3 artists</p>
          </div>

          <div style={{ height: 2, background: "#111", margin: "0 24px" }}>
            <div style={{ width: "100%", height: "100%", background: "#1db954", borderRadius: 1 }} />
          </div>

          <div style={{ padding: "20px 16px", flex: 1, overflowY: "auto" }}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
              {(selectedGenres.length > 0 
                ? [...new Map(selectedGenres.flatMap(g => ARTISTS_BY_GENRE[g] || []).map(a => [a.id, a])).values()]
                : DEFAULT_ARTISTS
              ).map(a => {
                const selected = selectedArtists.includes(a.id);
                return (
                  <div key={a.id} onClick={() => toggleArtist(a.id)} style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 14px", background: selected ? "rgba(29,185,84,0.1)" : "#111", border: `1.5px solid ${selected ? "#1db954" : "#1a1a1a"}`, borderRadius: 14, cursor: "pointer", transition: "all 0.2s" }}>
                    <div style={{ width: 38, height: 38, borderRadius: "50%", background: a.color, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, fontWeight: 700, color: "#000", flexShrink: 0 }}>{a.name[0]}</div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 13, fontWeight: 600, color: selected ? "#1db954" : "#fff", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{a.name}</div>
                      <div style={{ fontSize: 11, color: "#555", marginTop: 2 }}>Artist</div>
                    </div>
                    {selected && <svg viewBox="0 0 24 24" style={{ width: 16, height: 16, fill: "none", stroke: "#1db954", strokeWidth: 2.5, flexShrink: 0 }}><polyline points="20 6 9 17 4 12"/></svg>}
                  </div>
                );
              })}
            </div>
          </div>

          <div style={{ position: "fixed", bottom: 0, left: 0, right: 0, padding: "16px 24px 32px", background: "linear-gradient(0deg, #000 60%, transparent)", display: "flex", flexDirection: "column", alignItems: "center", gap: 10 }}>
            <p style={{ fontSize: 12, color: "#555" }}>{selectedArtists.length} selected {selectedArtists.length < 3 ? `(need ${3 - selectedArtists.length} more)` : "✓"}</p>
            <button onClick={() => selectedArtists.length >= 3 && setStep(4)} style={{ width: "100%", maxWidth: 320, padding: "15px", borderRadius: 50, border: "none", background: selectedArtists.length >= 3 ? "#1db954" : "#222", color: selectedArtists.length >= 3 ? "#000" : "#555", fontSize: 15, fontWeight: 700, cursor: selectedArtists.length >= 3 ? "pointer" : "not-allowed", fontFamily: "'Syne',sans-serif", transition: "all 0.2s" }}>
              Finish Setup →
            </button>
          </div>
        </div>
      )}

      {/* DONE SCREEN */}
      {step === 4 && (
        <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "40px 24px", textAlign: "center" }}>
          <div style={{ width: 96, height: 96, background: role === "artist" ? "#f59e0b" : "#1db954", borderRadius: 50, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 28, boxShadow: `0 12px 48px ${role === "artist" ? "rgba(245,158,11,0.4)" : "rgba(29,185,84,0.4)"}`, animation: "pop 0.4s ease" }}>
            <svg viewBox="0 0 24 24" style={{ width: 48, height: 48, fill: "none", stroke: "#000", strokeWidth: 2.5 }}><polyline points="20 6 9 17 4 12"/></svg>
          </div>
          <div style={{ fontFamily: "'Syne',sans-serif", fontSize: 28, fontWeight: 800, letterSpacing: "-0.5px", marginBottom: 12 }}>
            {role === "artist" ? "Welcome, Artist! 🎤" : "You're all set! 🎉"}
          </div>
          <p style={{ fontSize: 14, color: "#888", lineHeight: 1.7, maxWidth: 280, marginBottom: 16 }}>
            {role === "artist"
              ? "Your artist journey starts now. Upload your first song and start building your fanbase."
              : "Your music experience is personalized. Enjoy millions of songs!"}
          </p>
          {role === "artist" && (
            <div style={{ background: "rgba(245,158,11,0.08)", border: "1px solid rgba(245,158,11,0.2)", borderRadius: 12, padding: "12px 20px", marginBottom: 32, fontSize: 13, color: "#f59e0b" }}>
              💡 Go to Profile → Artist Profile to set up your page
            </div>
          )}
          <button onClick={handleComplete} style={{ width: "100%", maxWidth: 320, padding: "16px", borderRadius: 50, border: "none", background: role === "artist" ? "#f59e0b" : "#1db954", color: "#000", fontSize: 16, fontWeight: 700, cursor: "pointer", fontFamily: "'Syne',sans-serif" }}>
            {role === "artist" ? "Start Creating 🎵" : "Start Listening 🎵"}
          </button>
        </div>
      )}
    </div>
  );
}